"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _withIcon = _interopRequireDefault(require("./withIcon"));
const ChevronUpPeriscope = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M12 9.906l-6.293 6.301a1 1 0 01-1.414-1.414l7-7a1 1 0 011.414 0l7 7a1 1 0 01-1.414 1.414L12 9.907z",
  clipRule: "evenodd"
}));
const ChevronUpMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("polygon", {
  points: "11.9571068 10.6642136 15.9571068 14.6642136 16.6642136 13.9571068 11.9571068 9.25 7.25 13.9571068 7.95710678 14.6642136"
})));
const AbstractChevronUp = ({
  theme,
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(ChevronUpMDS, other) : _react.default.createElement(ChevronUpPeriscope, other);
var _default = exports.default = (0, _styledComponents.withTheme)((0, _withIcon.default)('ChevronUp')(AbstractChevronUp));